import { Controller } from '@hotwired/stimulus';

const BUTTON_SELECTORS = `
  button,
  input[type="submit"],
  input[type="button"]
`;

const FIELD_SELECTORS = `
  input[type="text"],
  input[type="email"],
  input[type="number"],
  input[type="password"],
  textarea,
  select
`;

export class FormLockController extends Controller {
  static values = {
    locked: {
      default: false,
      type: Boolean,
    },
  };

  lock(event) {
    if (this.lockedValue) return;

    // NOTE: disabled fields are left out of the submitted form data
    this.submitting = event?.type === 'submit';
    this.lockedValue = true;
  }

  unlock() {
    if (!this.lockedValue) return;

    this.submitting = false;
    this.lockedValue = false;
  }

  lockedValueChanged(value) {
    this.dispatch(value ? 'locked' : 'unlocked');

    const selectors = this.submitting ? BUTTON_SELECTORS : `${BUTTON_SELECTORS}, ${FIELD_SELECTORS}`;

    [...this.element.querySelectorAll(selectors)].forEach(el => el.disabled = value);
  }
}
